import {GemSettings} from './config/interface';

/**
 * Due to AEM editor limitation, all our components which are using "position: fixed"
 * i.e. modals, in-page navigation, doesn't work correctly in Edit and Preview mode.
 * See https://jira.s-mxs.net/browse/GEM-4024?focusedCommentId=1754241&page=com.atlassian.jira.plugin.system.issuetabpanels:comment-tabpanel#comment-1754241
 * @param componentName
 * @param gemSettings
 */
export function previewOrEditWithMessage(componentName: string, gemSettings: GemSettings): boolean {
    if (previewOrEditMode(gemSettings)) {
        alert(
            `The ${componentName} cannot be displayed correctly in Edit and Preview mode. For a preview of the component please open the Review Page or Live Page.`,
        );
        return true;
    }

    return false;
}

export function previewOrEditMode(gemSettings: GemSettings): boolean {
    return ['EDIT', 'PREVIEW'].includes(gemSettings.wcmMode) && gemSettings.environment !== 'LOCAL' && !window.location.hostname.startsWith('review.gem');
}
